module.exports = __webpack_public_path__ + "static/media/top_square1.2be0fbd5.svg";